import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import '@/assets/css/onboarding.css';
import { setActiveOnboardingDriver } from '@/store/onboarding-store';
import i18n from '../i18n';
import { waitForAllElements } from './waitForDomElements';

const startSingleSubscriptionGuide = (options = {}) => {
  const { onFinish = () => {} } = options;

  const steps = [
    {
      element: '.single-subscription-guide-details-card',
      popover: {
        title: i18n.t('onboarding.single_subscription.guide.details_title'),
        description: i18n.t('onboarding.single_subscription.guide.details_description'),
      },
    },
    {
      element: '.single-subscription-guide-billing-card',
      popover: {
        title: i18n.t('onboarding.single_subscription.guide.billing_title'),
        description: i18n.t('onboarding.single_subscription.guide.billing_description'),
      },
    },
    {
      element: '.single-subscription-guide-options-activator',
      popover: {
        title: i18n.t('onboarding.single_subscription.guide.options_title'),
        description: i18n.t('onboarding.single_subscription.guide.options_description'),
      },
      onHighlightStarted: () => {
        window.dispatchEvent(new Event('onboarding:single-subscription-guide-open-options-menu'));
      },
    },
    {
      element: '.single-subscription-guide-edit-payment-action',
      popover: {
        title: i18n.t('onboarding.single_subscription.guide.edit_payment_title'),
        description: i18n.t('onboarding.single_subscription.guide.edit_payment_description'),
      },
      onHighlightStarted: () => {
        window.dispatchEvent(new Event('onboarding:single-subscription-guide-open-options-menu'));
      },
    },
  ];

  const requiredSelectors = [
    '.single-subscription-guide-details-card',
    '.single-subscription-guide-billing-card',
    '.single-subscription-guide-options-activator',
  ];

  return waitForAllElements(requiredSelectors)
    .then((allFound) => {
      if (!allFound) {
        return false;
      }

      if (document.querySelector('.single-subscription-guide-invoice-btn-first')) {
        steps.splice(2, 0, {
          element: '.single-subscription-guide-invoice-btn-first',
          popover: {
            title: i18n.t('onboarding.single_subscription.guide.invoice_title'),
            description: i18n.t('onboarding.single_subscription.guide.invoice_description'),
          },
        });
      }

      let isCompleted = false;

      const onboardingDriver = driver({
        showProgress: true,
        allowClose: false,
        showButtons: ['previous', 'next'],
        prevBtnText: i18n.t('onboarding.prev'),
        nextBtnText: i18n.t('onboarding.next'),
        doneBtnText: i18n.t('onboarding.done'),
        steps: steps.map((step, index) => {
          if (index === steps.length - 1) {
            return {
              ...step,
              popover: {
                ...step.popover,
                onNextClick: () => {
                  isCompleted = true;
                  onboardingDriver.destroy();
                },
              },
            };
          }
          return step;
        }),
        onDestroyed: () => {
          window.dispatchEvent(new Event('onboarding:single-subscription-guide-close-options-menu'));
          if (isCompleted) {
            onFinish();
          } else if (options.onDeactivated) {
            options.onDeactivated();
          }
        },
      });

      setActiveOnboardingDriver(onboardingDriver);
      onboardingDriver.drive();
      return true;
    });
};

export { startSingleSubscriptionGuide };
export default startSingleSubscriptionGuide;
